import React from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "@finitless/shared/config";
import { useUIStore } from "@finitless/shared/stores";
import "./index.css";
import "./i18n";
import App from "./App.jsx";

// Reconcile the persisted store with the pre-paint bootstrap before React mounts.
useUIStore.getState().initializeTheme();

// Initialize Sentry as early as possible
initSentry();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
